import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PlainContentModel } from '@libs/cms/models';
import { BypassSecurityPipe } from '@libs/shared/ui';
import { HeadlinesComponent } from '../../items';
import { ContentBaseComponent } from '../content-base.component';

@Component({
  selector: 'ui-plain',
  templateUrl: './plain.component.html',
  styleUrls: ['./plain.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeadlinesComponent,
    BypassSecurityPipe,
  ],
})
export class PlainComponent extends ContentBaseComponent<PlainContentModel> {
}
